import { EnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Provides the application with Brain Tab, the universal navigation widget for CS web properties
 * @returns app initializer provider
 */
export const provideBrainTab = (): EnvironmentProviders =>
    provideAppInitializer(() => {
        const initializerFn = brainTabInitializer();
        return initializerFn();
    });

export const brainTabInitializer = () => {
    (window as any).braintab = {
        product: 'genesys-cloud-cx',
        theme: 'navy',
        onInit: (el) => {
            // tablet max-width
            if (window.innerWidth <= 1024 && !!el.remove) {
                el?.remove();
            }
        },
        onLogin: () => {},
        onToggle: () => {},
    };

    return async () => {
        await new Promise<void>((resolve, _) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = environment.braintab.css;
            document.head.appendChild(link);

            const script = document.createElement('script');
            script.async = true;
            script.id = 'gkn-brain-tab';
            script.type = 'text/javascript';
            script.src = environment.braintab.src;

            script.onerror = async () => resolve(); // The script may have been blocked by an ad blocker
            script.onload = async () => {
                (window as any).braintab.init(window, document, 'custom-container', 'gkn-brain-tab', false);
                resolve();
            };

            document.head.appendChild(script);

            console.debug('[Injectors][BrainTabInjector] Successfully injected.');
        });
    };
};
